import { Trans } from '@lingui/react/macro';
import { ComingSoon } from './components/ComingSoon';

export function Courses(): React.JSX.Element {
  return <ComingSoon title={<Trans>Courses</Trans>} />;
}
